import { useState } from "react";
import {
  FileText,
  LayoutGrid,
  FileCode,
  LayoutPanelTop,
  Settings,
  ChevronRight,
  ChevronLeft,
  TableProperties
} from "lucide-react";
import { NavLink } from "react-router-dom";
import { getUsername,getInitials } from "../../utils/common_functions";

// Reusable NavItem component
const NavItem = ({ to, icon, label, isSidebarOpen }) => (
  <NavLink
    to={to}
    className={({ isActive }) =>
      `group relative flex items-center p-2 rounded hover:bg-gray-700 transition-all duration-200 ${
        isSidebarOpen ? "justify-start" : "justify-center"
      } ${isActive ? "bg-white text-black font-medium" : "text-white"}`
    }
  >
    {icon}
    {isSidebarOpen ? (
      <span className="ml-2">{label}</span>
    ) : (
      <span className="absolute left-full ml-2 whitespace-nowrap bg-gray-800 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-50 shadow-lg">
        {label}
      </span>
    )}
  </NavLink>
);

// Main Sidebar component
const Sidebar = ({ logout,isSidebarOpen }) => {
//  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return (
    <aside
      className={`h-screen ${isSidebarOpen ? "w-64" : "w-24"} transition-all duration-300 bg-[#0f172a] text-white flex flex-col justify-between fixed left-0 top-0 z-50`}
    >
      <div>
        {/* Header */}
        <div
          className={`p-4 text-xl font-bold border-b border-gray-700 flex items-center ${
            isSidebarOpen ? "justify-between" : "justify-center"
          }`}
        >
          <div className="flex items-center">
            <FileText className="h-5 w-5" />
            {isSidebarOpen && <span className="ml-2">SpecAgent</span>}
          </div>
          {/* <button onClick={() => setIsSidebarOpen(!isSidebarOpen)}>
            {isSidebarOpen ? (
              <ChevronLeft className="h-4 w-4" />
            ) : (
              <ChevronRight className="h-4 w-4" />
            )}
          </button> */}
        </div>

        {/* Navigation */}
        <nav className="p-4 space-y-1">
          <NavItem
            to="/overview"
            icon={<LayoutGrid className="h-5 w-5" />}
            label="Overview"
            isSidebarOpen={isSidebarOpen}
          />
          <NavItem
            to="/tech-spec"
            icon={<FileCode className="h-5 w-5" />}
            label="Manage Specifications"
            isSidebarOpen={isSidebarOpen}
          />
          <NavItem
            to="/infrastructure-context/list"
            icon={<LayoutPanelTop className="h-5 w-5" />}
            label="Infrastructure Contexts"
            isSidebarOpen={isSidebarOpen}
          />
        <NavItem
            to="/report"
            icon={<TableProperties className="h-5 w-5" />}
            label="GxP Compliance"
            isSidebarOpen={isSidebarOpen}
          />
        </nav>
      </div>

      {/* Footer */}
      <div
        className={`p-4 border-t border-gray-700 flex items-center ${
          isSidebarOpen ? "justify-between" : "justify-center"
        }`}
      >
        <div className="flex items-center">
          <div className="bg-blue-500 text-white rounded-full w-8 h-8 flex items-center justify-center text-xs font-bold">
            {getInitials(getUsername())}
          </div>
          {isSidebarOpen && (
            <span className="ml-2 text-sm font-medium">{getUsername()}</span>
          )}
        </div>
        <Settings
          onClick={logout}
          className="h-4 w-4 text-gray-400 hover:text-white cursor-pointer"
        />
      </div>
    </aside>
  );
};

export default Sidebar;
